import { isEmpty } from 'lodash';

import { TRANSMISSION_DATA } from 'commons-vehicle/constants/dataConversions.js';
import { getDescriptionData } from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import TransmissionModel from 'commons-vehicle/ModelYear/models/TransmissionModel.js';
/* eslint import/prefer-default-export: 0 */

export function resetTransmissionFromConfigurationData(configurationTransmissionData) {
    if (
        isEmpty(configurationTransmissionData) ||
        configurationTransmissionData.length <= TRANSMISSION_DATA.DESCRIPTION
    ) {
        return new TransmissionModel();
    }

    const selectionCode =
        `${configurationTransmissionData[TRANSMISSION_DATA.TYPE_CODE]}-` +
        `${configurationTransmissionData[TRANSMISSION_DATA.SPEEDS]}-` +
        `${configurationTransmissionData[TRANSMISSION_DATA.IS_CVT]}`;

    return new TransmissionModel({
        selectionCode,
        code: '',
        typeCode: configurationTransmissionData[TRANSMISSION_DATA.TYPE_CODE],
        rank: configurationTransmissionData[TRANSMISSION_DATA.TYPE_CODE] === 'MA' ? 1 : 2,
        type: configurationTransmissionData[TRANSMISSION_DATA.TYPE],
        speeds: configurationTransmissionData[TRANSMISSION_DATA.SPEEDS],
        isCVT: configurationTransmissionData[TRANSMISSION_DATA.IS_CVT],
        description: getDescriptionData(configurationTransmissionData[TRANSMISSION_DATA.DESCRIPTION]),
    });
}

export default {
    resetTransmissionFromConfigurationData,
};
